import ButtonSkeleton from '@/components/skeletons/Button'
import { useConfirmation } from '@/contexts/confirmation'
import CloneIcons from '@/icons/EditIcons'
import {
    cloneContractCustomer,
    getContractCustomer,
} from '@/modules/Contract/services/customer'
import { CustomerContract } from '@/modules/Contract/types'
import { ResponseObject } from '@/types/shared'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from 'vnetwork-ui'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Clone = () => {
    const { t } = useTranslation()
    const { setConfirmation } = useConfirmation()
    const { contractID } = useParams()
    const navigate = useNavigate()
    const {
        data: contract,
        isLoading,
        renderState,
    } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.CONTRACT_DETAIL, contractID || ''],
            queryFn: () =>
                getContractCustomer({ contractID: Number(contractID) }),
            enabled: !!contractID,
        },
        {
            loadingComponent: <ButtonSkeleton width={242} />,
        }
    )

    const { mutate: cloneContractMutate } = useMutationWithHandler(
        {
            mutationFn: (reason: string) => {
                return cloneContractCustomer({
                    contractID: Number(contractID),
                    reason: reason,
                })
            },
        },
        {
            successMessage: t('contract-clone-success'),
            reactQueryKeys: QUERY_KEYS.CONTRACTS,
            onSuccess: (response: ResponseObject<CustomerContract>) => {
                navigate(
                    generatePathDatacentral(paths.contractDetail, {
                        id: response?.result?.contract_id.toString(),
                    })
                )
            },
        }
    )

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <Button
            size="small"
            variant="contained"
            startIcon={<CloneIcons />}
            disabled={contract?.result?.contract_status !== 'active'}
            loading={isLoading}
            onClick={() => {
                setConfirmation({
                    open: true,
                    title: t('contract-clone-with-new-contract-number-id'),
                    description: t(
                        'contract-clone-with-new-contract-number-id-desc-2'
                    ),
                    useReason: true,
                    onConfirm: (reason) => cloneContractMutate(reason || ''),
                })
            }}
        >
            {t('contract-clone')}
        </Button>
    )
}

export default Clone
